/**
 * InkyPic Header Component
 * Displays brand logo and navigation
 */

import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="brand">
          <h1 className="brand-name">
            <span className="brand-icon">🎨</span>
            InkyPic
          </h1>
          <p className="brand-tagline">Bring Your Memories to Life</p>
        </div>
      </div>
    </header>
  );
};

export default Header;
